module.exports = __webpack_public_path__ + "img/icon_manual_profile.a6da0d93.png";